var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreBenefitsLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.167 27.5H13.167C10.4056 27.5 8.16699 29.7386 8.16699 32.5V50C8.16699 52.7614 10.4056 55 13.167 55H48.167C50.9284 55 53.167 52.7614 53.167 50V32.5C53.167 29.7386 50.9284 27.5 48.167 27.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.167 27.5V17.5C18.167 14.1848 19.484 11.0054 21.8282 8.66117C24.1724 6.31696 27.3518 5 30.667 5C33.9822 5 37.1616 6.31696 39.5058 8.66117C41.85 11.0054 43.167 14.1848 43.167 17.5V27.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsLock);
export default __webpack_public_path__ + "static/media/core-benefits-lock.1007c2c82fc55b3e9394201a87f79b08.svg";
export { ForwardRef as ReactComponent };